import axios from "@/api/axiosInstance";
import { UnsubscribeRecurringEmailRecipientResponse } from "./types";

export const unsubscribeRecurringEmailRecipient = async (
  recurringEmail: string,
  recipientUuid: string,
): Promise<UnsubscribeRecurringEmailRecipientResponse> => {
  const response =
    await axios.delete<UnsubscribeRecurringEmailRecipientResponse>(
      `/api/private/recurring-emails/${recurringEmail}/recipients/${recipientUuid}`,
    );
  return response.data;
};
